// Simple product offers functionality - no automatic opening
console.log('Product offers script loaded');

// Copy code functionality for main list
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.main-offer-copy').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const code = this.getAttribute('data-code');
      
      navigator.clipboard.writeText(code).then(() => {
        console.log('Code copied:', code);
        
        // Update button to show success
        const originalHTML = this.innerHTML;
        this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
        
        setTimeout(() => {
          this.innerHTML = originalHTML;
        }, 2000);
      });
    });
  });
});
